define('home/templates/settingsMenu',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"empty-message\">\n"
    + container.escapeExpression(helpers.gettext.call(depth0 != null ? depth0 : {},"Pick a settings page on the left",{"name":"gettext","hash":{},"data":data}))
    + "\n</div>\n";
},"useData":true})

});
